import type { LocationData } from "@/data/types";
import locationDataJson from "@/data/location.json";

export function useLocationData() {
  const locationData = locationDataJson as LocationData;
  return { locationData, loading: false, error: null };
}